export type SortOption =
  | 'relevance'
  | 'price_asc'
  | 'price_desc'
  | 'name_asc'
  | 'name_desc'
  | 'availability'

export const SORT_OPTIONS: { value: SortOption; label: string }[] = [
  { value: 'relevance', label: 'By Relevance' },
  { value: 'price_asc', label: 'By Price: low to high' },
  { value: 'price_desc', label: 'By Price: high to low' },
  { value: 'name_asc', label: 'By Name A-Z' },
  { value: 'name_desc', label: 'By Name Z-A' },
  { value: 'availability', label: 'By Availability' },
]

export function parseItemsSortParam(raw: string | null): SortOption {
  if (
    raw === 'price_asc' ||
    raw === 'price_desc' ||
    raw === 'name_asc' ||
    raw === 'name_desc' ||
    raw === 'availability'
  ) {
    return raw
  }
  return 'relevance'
}
